import { apiService } from './apiService'
import { endpoints } from './endpoints'

const domain = endpoints.internalSchedules

export const internalSchedulesService = {
	getAllActive: () => apiService.get(domain.getAllActive),
	getAllComplete: () => apiService.get(domain.getAllCompleted),
	create: (data: Object) => apiService.post(domain.create, data),
	update: (data: Object) => apiService.post(domain.update, data),
	delete: (id: string) => apiService.delete(domain.delete(id), {}),
	updateOrder: (scheduleId: string, deliveries: string[]) => apiService.post(domain.updateOrder, { scheduleId, deliveries }),
	completeSchedule: (data: Object) => apiService.post(domain.completeSchedule, data),
	notifySofiaOrdersDelivery: (data: Object) => apiService.post(domain.notifySofiaOrdersDelivery, data)
}
